module.exports = "a.btn.line:hover{\r\n    border: 1px solid var(--secondary-color);\r\n    border: 1px solid var(--external-color);\r\n    /* color: #ffffff; */\r\n}\r\n\r\na.btn.line{\r\n    border: 1px solid #E0E0E0;\r\n}\r\n\r\n.ellipsiss{\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/slots/addtocalender/addtocalender.component.css
// module id = ./src/app/slots/addtocalender/addtocalender.component.css
// module chunks = main